import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'motion/react';
import './Navbar.css';

const SECTIONS = [
  { id: 'about', label: 'About' },
  { id: 'skills', label: 'Skills' },
  { id: 'experience', label: 'Work' },
  { id: 'projects', label: 'Projects' },
  { id: 'learning', label: 'Learning' },
  { id: 'gallery', label: 'Gallery' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('home');
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.3 });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Scroll-spy: the section crossing the middle band of the viewport is "active"
  useEffect(() => {
    const spy = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); }),
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
    );
    ['home', ...SECTIONS.map((s) => s.id)].forEach((id) => {
      const el = document.getElementById(id);
      if (el) spy.observe(el);
    });
    return () => spy.disconnect();
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <motion.div className="nav-progress" style={{ scaleX: progress }} aria-hidden="true" />

      <header className={`nav-top ${scrolled ? 'is-scrolled' : ''}`}>
        <div className="container nav-top-inner">
          <a href="#home" className="nav-brand mono" onClick={go('home')} aria-label="Back to top">
            <span className="nav-brand-dot" aria-hidden="true" />NE
          </a>
          <a href="mailto:nevardogan@hotmail.com" className="btn btn-primary nav-cta">Let's talk</a>
        </div>
      </header>

      <nav className="nav-modes" aria-label="Sections">
        <ul>
          {SECTIONS.map(({ id, label }) => {
            const isActive = active === id;
            return (
              <li key={id}>
                <a
                  href={`#${id}`}
                  className={`nav-mode ${isActive ? 'is-active' : ''}`}
                  onClick={go(id)}
                  aria-current={isActive ? 'true' : undefined}
                >
                  {isActive && (
                    <motion.span
                      layoutId="nav-mode-pill"
                      className="nav-mode-pill"
                      transition={{ type: 'spring', stiffness: 380, damping: 32 }}
                    />
                  )}
                  <span className="nav-mode-label">{label}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
